import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  AddPartApi,
  GetAllCompanies,
  GetAllUnits,
  GetAllCategories,
  GetAllSalesCategories,
  GetAllPNStatus,
  GetPartById,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const AddSerialized = () => {
  const navigate = useNavigate();
  const { userID } = useStateContext();
  const [getscategorys, setSCategorys] = useState([]);
  const [getunits, setUnits] = useState([]);
  const [getcompanys, setcompanys] = useState([]);
  const [getcategories, setCategories] = useState([]);
  const [getpnstatus, setPNStatus] = useState([]);
  const [formData, setFormData] = useState({
    company: "Select Company",
    description: "",
    category: "Select Category",
    sales_category: "Select Sales Category",
    unit: "Select Unit",
    location: "",
    cost_price: "0.0",
    sale_price: "0.0",
    markup: "0.0",
    status: "Select Status",
    serialized: false,
    pn_note: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleChangeSerial = () => {
    const serr = formData.serialized;
    setFormData((prev) => ({ ...prev, serialized: serr ? false : true }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    try {
      const response = await AddPartApi(
        formData.category.value,
        formData.sales_category.value,
        formData.description,
        formData.unit.value,
        formData.location,
        formData.cost_price,
        formData.sale_price,
        formData.markup,
        formData.serialized,
        formData.status.value,
        formData.company.value,
        formData.pn_note,
        userID,
      );
      if (response.success) {
        showSuccessToast("Success!", "Part added successfully!");
        navigate("/Part");
      } else
        showErrorToast("Error!", "Part failed to add!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Part did not save!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      TimeoutUtility.resetTimeout();
      await GetAllCompanies()
        .then((resp) => {
          const companyOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.company_id,
          }));
          setcompanys(companyOptions || []);
        })
        .catch((err) => console.log(err.message));
      await GetAllCategories()
        .then((resp) => {
          const categOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.category_id,
          }));
          setCategories(categOptions || []);
        })
        .catch((err) => console.log(err.message));
      await GetAllSalesCategories()
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.sales_category_id,
          }));
          setSCategorys(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
      await GetAllUnits()
        .then((resp) => {
          const unitOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.unit_id,
          }));
          setUnits(unitOptions || []);
        })
        .catch((err) => console.log(err.message));
      await GetAllPNStatus()
        .then((resp) => {
          const statsOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.pn_status_id,
          }));
          setPNStatus(statsOptions || []);
        })
        .catch((err) => console.log(err.message));

      if (localStorage.getItem("copyPart")) {
        const cP = localStorage.getItem("copyPart");
        if (cP && cP !== "null") {
          await GetPartById(cP)
            .then((result) => {
              setFormData({
                company: {
                  label: result.data.company,
                  value: result.data.company_id,
                },
                description: result.data.description || "",
                category: {
                  label: result.data.category,
                  value: result.data.category_id,
                },
                sales_category: {
                  label: result.data.s_category,
                  value: result.data.s_category_id,
                },
                unit: { label: result.data.unit, value: result.data.unit_id },
                location: result.data.stockroom_location || "",
                status: {
                  label: result.data.pn_status,
                  value: result.data.pn_status_id,
                },
                serialized: result.data.serialized,
              });
            })
            .catch((err) => console.log(err.message));
        }
        localStorage.setItem("copyPart", null);
      }
    }
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ADD PART" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <SelectField
                  label="Company:"
                  name="company"
                  value={formData.company}
                  options={getcompanys}
                  onChange={handleSelectChange}
                  placeholder="Company"
                  compulsory={true}
                  error={errors.company}
                />
                <TextAreaField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Part Description"
                  compulsory={true}
                  error={errors.description}
                />
                <SelectField
                  label="Category:"
                  name="category"
                  value={formData.category}
                  options={getcategories}
                  onChange={handleSelectChange}
                  placeholder="Category"
                  compulsory={true}
                  error={errors.category}
                />
                <SelectField
                  label="Sales Category:"
                  name="sales_category"
                  value={formData.sales_category}
                  options={getscategorys}
                  onChange={handleSelectChange}
                  placeholder="Sales Category"
                  compulsory={true}
                  error={errors.sales_category}
                />
                <SelectField
                  label="Unit:"
                  name="unit"
                  value={formData.unit}
                  options={getunits}
                  onChange={handleSelectChange}
                  placeholder="Unit"
                  compulsory={true}
                  error={errors.unit}
                />
                <TextInputField
                  label="Stockroom Location:"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Stockroom Location"
                  error={errors.location}
                />
              </div>
            </Col>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <DoubleField
                  label="Cost Price:"
                  name="cost_price"
                  value={formData.cost_price}
                  onChange={handleChange}
                  placeholder="Cost Price"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.cost_price}
                />
                <DoubleField
                  label="Sale Price:"
                  name="sale_price"
                  value={formData.sale_price}
                  onChange={handleChange}
                  placeholder="Sale Price"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.sale_price}
                />
                <DoubleField
                  label="Markup %:"
                  name="markup"
                  value={formData.markup}
                  onChange={handleChange}
                  placeholder="Markup"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.markup}
                />
                <SelectField
                  label="PN Status:"
                  name="status"
                  value={formData.status}
                  options={getpnstatus}
                  onChange={handleSelectChange}
                  placeholder="PN Status"
                  compulsory={true}
                  error={errors.status}
                />
                <div className="form-group mt-3">
                  <label className="label">Serialized:</label>
                  <input
                    type="checkbox"
                    className="input"
                    name="serialized"
                    checked={formData.serialized}
                    onChange={handleChangeSerial}
                  />
                </div>
                <TextAreaField
                  label="Notes:"
                  name="pn_note"
                  value={formData.pn_note}
                  onChange={handleChange}
                  placeholder="Part Notes"
                  error={errors.pn_note}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Create"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddSerialized;
